import BaseComponent from '../../base/base_component';
import DOM from '../../utils/dom';
import {LOGIN_BUTTONS_SELECTORS} from './login_buttons_consts';
import {GNWP_SOURCES} from '../external_links/external_links_consts';
import ServiceFactory from '../../services/service_factory';
import DependenciesFactory from './dependencies_factory';
import {SYSTEM_EVENTS, CLIENT_EVENTS} from '../../events/events';
import {MARKETING_FLOWS} from '../../services/integration/integration_const';
import Event from '../../utils/event';
import _ from '../../utils/underscore';

const buttonsView = require('./view/login-buttons.html');
const ENVIRONMENTS = {
    LOBBY: 'lobby',
    GAME: 'game'
};

export default class LoginButtonsComponentController extends BaseComponent {
    static CLASS = 'LoginButtonsComponentController';

    static DIRECTIVE = 'cgp-directive-login_buttons';
    _selector = 'cgp-login-buttons-component';

    init(params) {
        super.init(params);
        this._environment = params.env;
        this._showRegisterButton = params.showRegister;
        this._gameType = params.gametype;
        this._gameName = params.gameName;
        this._isRealGame = params.isReal;
        this._marketingDataFunctions = _.safeJSON(params.marketingDataFn, null) || {};

        this._serviceFactory = params.serviceFactory || ServiceFactory.create();
        this._dependenciesFactory = params.dependenciesFactory || DependenciesFactory.create({
            serviceFactory: this._serviceFactory
        });
    }

    _environment = null;
    _showRegisterButton = null;
    _gameType = null;
    _gameName = null;
    _isRealGame = null;
    _marketingDataFunctions = null;

    _serviceFactory = null;
    _dependenciesFactory = null;

    start() {
        this._renderComponent();
        this._loginClickSubscription = this._subscribeToLoginButtonClick();
        this._registerClickSubscription = this._subscribeToRegisterButtonClick();
        if(!this._showRegisterButton) {
            let loginButtonHtmlElement = this.getEl().querySelector('.login_buttons_register');
            if(loginButtonHtmlElement) {
                DOM.addAttribute(loginButtonHtmlElement, 'style', 'display: none');
            }
        }
        return this;
    }

    _loginClickSubscription = null;
    _registerClickSubscription = null;

    shutDown() {
        if(this._loginClickSubscription) {
            this._loginClickSubscription.dispose();
        }

        if (this._registerClickSubscription) {
            this._registerClickSubscription.dispose();
        }
    }

    _renderComponent() {
        DOM.html(this.bake(buttonsView), this.getEl());
    }

    _subscribeToLoginButtonClick() {
        let button = this._getButton(LOGIN_BUTTONS_SELECTORS.LOGIN_BUTTON_ID);

        return this._dependenciesFactory.createLoginButtonClickObservable(button)
            .forEach(() => {
                this.sendAnalytics('Login');
                Event.fire(CLIENT_EVENTS.LOGIN_BUTTON_CLICKED);
                if(!this._serviceFactory.countryService().checkIfShouldRedirect('login')) {
                    this._serviceFactory.oAuth2Service().tryToRememberMe()
                        .catch(() => {
                            this._serviceFactory.webLoginService().openLoginForm({
                                marketingDataFunction: this._marketingDataFunctions[MARKETING_FLOWS.REGISTER_IN_LOGIN]
                            });
                    });
                }
            });
    }

    _subscribeToRegisterButtonClick() {
        let button = this._getButton(LOGIN_BUTTONS_SELECTORS.REGISTER_BUTTON_ID);

        return this._dependenciesFactory.createRegisterButtonClickObservable(button)
            .forEach(() => {
                return this.serviceFactory.regulationService().stepsBeforeOpenLoginAndRegistration().then(()=> {
                    let fn = this._marketingDataFunctions[MARKETING_FLOWS.REGISTER];
                    if(fn) {
                        this._serviceFactory.integrationService().executeMarketingDataFunction(fn);
                    }

                    Event.fire(SYSTEM_EVENTS.INCOMING_MARKETING_FLOW, MARKETING_FLOWS.REGISTER);

                    this.sendAnalytics('Register');

                    if(!this._serviceFactory.countryService().checkIfShouldRedirect('register')) {
                        this._serviceFactory.openLinkService().openLink({source:GNWP_SOURCES.MEMBERSHIP, forceHideCloseButton: this.serviceFactory.regulationService().getRegulation().forceHideCloseButtonInMembership()});
                    }
                });
        });
    }

    _getButton(buttonId) {
        return this.getEl().querySelectorAll(buttonId)[0];
    }

    sendAnalytics(action) {

        let analyticObj = {
            category: 'Client_LoginButtons',
            action: action
        };

        if (this._environment === ENVIRONMENTS.GAME) {
            analyticObj.category =  this._isRealGame ? 'Client_GameFrame_Real' : 'Client_GameFrame_Anonymous';
            analyticObj.label = this._gameType + '_' + this._gameName.replace(/ /g, '');
        }

        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, analyticObj);
    }

}

